import actionTypes from './actionTypes';
import namespace from './namespace';
export function GetServiceConfig(data) {
  return {
    type: namespace + '/' + actionTypes.GET_SERVICE_CONFIG,
    data
  };
}
export function GetChangePasswordConfig(data) {
  return {
    type: namespace + '/' + actionTypes.GET_CHANGE_PASSWORD_CONFIG,
    data
  };
}